import React from 'react';
import cn from 'classnames';
import { useWidth } from '../hooks/useWidth';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import s from './Viewer.scss';
const Viewer = (props)=>{
    var _props_node_externalRenderers, _props_node_extensionConfig;
    const attrs = props.node.attrs;
    const { alignment, deviation } = attrs;
    const Renderer = (_props_node_externalRenderers = props.node.externalRenderers) === null || _props_node_externalRenderers === void 0 ? void 0 : _props_node_externalRenderers.deviation;
    const config = (_props_node_extensionConfig = props.node.extensionConfig) === null || _props_node_extensionConfig === void 0 ? void 0 : _props_node_extensionConfig.deviation;
    const align = alignment === 'left' ? s['left'] : alignment === 'right' ? s['right'] : s['center'];
    var _attrs_width, _ref, _config_smallMedia;
    const { width } = useWidth((_ref = (_attrs_width = attrs.width) !== null && _attrs_width !== void 0 ? _attrs_width : config.defaultWidth) !== null && _ref !== void 0 ? _ref : 780, config.defaultWidth, (_config_smallMedia = config.smallMedia) !== null && _config_smallMedia !== void 0 ? _config_smallMedia : false, attrs.alignment, props.node.containerWidth);
    const Deviation = /*#__PURE__*/ React.createElement("figure", {
        className: s['deviation-figure'],
        "data-da-type": "da-deviation",
        "data-deviation": JSON.stringify(deviation),
        "data-width": attrs.width,
        "data-link": attrs.link,
        "data-alignment": attrs.alignment
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "editorExtDeviationViewer",
        humanError: "Oops, this deviation could not be shown."
    }, /*#__PURE__*/ React.createElement(Renderer, {
        deviation: attrs.deviation,
        width: width,
        extOptions: config,
        link: attrs.link
    })));
    return /*#__PURE__*/ React.createElement("div", {
        key: `img-${width}`,
        className: cn(s['deviation-container'], align, (config === null || config === void 0 ? void 0 : config.smallMedia) && s['small-media'], s[`preset-${props.node.presetId}`])
    }, Deviation);
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map